<mat-card class="card-style-full px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center gap-2">
    <div class="flex-1">
      <mat-card-title class="">Cadastro Subcliente</mat-card-title>
    </div>
    <!--    <button class="btn-icon" (click)="close()">-->
    <!--      <mat-icon>close</mat-icon>-->
    <!--    </button>-->
    <button mat-flat-button class="btn-tg-cancel w-1/12" (click)="close()">
      Cancelar
    </button>
    <button
      mat-flat-button
      class="btn-tg w-1/12"
      [disabled]="checkInvalidForm()"
      (click)="createClient()"
    >
      @if (loading) {
        <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
      } @else {
        Cadastrar
      }
    </button>
  </mat-card-header>

  <div class="mt-4 mb-2"></div>
  <mat-accordion multi>
    <mat-expansion-panel expanded>
      <mat-expansion-panel-header class="panel-header">
        <mat-panel-title>
          <h4>Subcliente</h4>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="mt-4">
        <!--        <mat-form-field class="input-tg w-1/5" appearance="outline">-->
        <!--          <mat-label>Tipo Cliente</mat-label>-->
        <!--          <mat-select [(value)]="typeClient">-->
        <!--            @for (type of listTypeClient; track type) {-->
        <!--              <mat-option [value]="type.id">{{ type.description }}</mat-option>-->
        <!--            }-->
        <!--          </mat-select>-->
        <!--        </mat-form-field>-->
        <div [formGroup]="formLegalEntity" [hidden]="typeClient != 'legal'">
          <div class="flex justify-between gap-4 items-center">
            <mat-form-field class="input-tg w-3/12" appearance="outline">
              <mat-label>Tipo de Cliente</mat-label>
              <mat-select formControlName="personType"
                          (selectionChange)="personTypeChange()"
              >
                @for (type of ListPersonType; track type) {
                  <mat-option [value]="type.value">{{ type.description }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="flex justify-between gap-4 items-center">
            <mat-form-field class="input-tg"
                            [ngClass]="individualPerson ? 'w-8/12' : 'w-5/12'"
                            appearance="outline">
              <mat-label>Nome</mat-label>
              <input matInput formControlName="name" />
            </mat-form-field>

            @if(!individualPerson){
              <mat-form-field
                class="input-tg w-5/12" appearance="outline">
                <mat-label>Razão social</mat-label>
                <input matInput formControlName="corporate_name" />
              </mat-form-field>
            }

            <mat-form-field
              [ngClass]="individualPerson ? 'w-4/12' : 'w-2/12'"
              class="input-tg" appearance="outline">
              <mat-label>
                @if(!individualPerson){
                  CNPJ
                }@else{
                  CPF
                }
              </mat-label>
              <input
                matInput
                formControlName="cnpj"
                [mask]="individualPerson ? '000.000.000-00' : '00.000.000/0000-00'"              />
            </mat-form-field>
          </div>
          @if(!individualPerson){
            <div class="flex justify-between gap-4 items-center">
              <mat-form-field class="input-tg w-6/12" appearance="outline">
                <mat-label>Inscrição Estadual</mat-label>
                <input matInput formControlName="reg_state" />
              </mat-form-field>

              <mat-form-field class="input-tg w-6/12" appearance="outline">
                <mat-label>Inscrição Municipal</mat-label>
                <input matInput formControlName="reg_municipal" />
              </mat-form-field>
            </div>
          }
        </div>
        <div [formGroup]="formIndividual" [hidden]="typeClient != 'individual'">
          <div class="flex justify-between gap-4 items-center">
            <mat-form-field class="input-tg w-10/12" appearance="outline">
              <mat-label>Nome</mat-label>
              <input matInput formControlName="name" />
            </mat-form-field>

            <mat-form-field class="input-tg w-2/12" appearance="outline">
              <mat-label>CPF</mat-label>
              <input matInput formControlName="cpf" [mask]="'999.999.999-99'" />
            </mat-form-field>
          </div>
        </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel (opened)="panelSubClient = true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h4>Clientes*</h4>
        </mat-panel-title>
      </mat-expansion-panel-header>
      @if (panelSubClient) {
        <div>
          <associate-client-create
            [client]="this.item.clientData"
            (response)="getList($event, 'associateClients')"
          ></associate-client-create>
        </div>
      }
    </mat-expansion-panel>

    <mat-expansion-panel (opened)="panelAdress = true">
      <mat-expansion-panel-header>
        <mat-panel-title> <h4>Endereço</h4> </mat-panel-title>
      </mat-expansion-panel-header>
      @if (panelAdress) {
        <div>
          <address-client-create (response)="getList($event, 'address')" />
        </div>
      }
    </mat-expansion-panel>

    <mat-expansion-panel (opened)="panelContact = true">
      <mat-expansion-panel-header>
        <mat-panel-title> <h4>Contatos</h4> </mat-panel-title>
      </mat-expansion-panel-header>
      @if (panelContact) {
        <div>
          <contact-client-create (response)="getList($event, 'contact')" />
        </div>
      }
    </mat-expansion-panel>

    <mat-expansion-panel (opened)="panelResponsable = true">
      <mat-expansion-panel-header>
        <mat-panel-title> <h4>Responsáveis</h4> </mat-panel-title>
      </mat-expansion-panel-header>
      @if (panelResponsable) {
        <div>
          <responsible-client-create
            (response)="getList($event, 'responsible')"
          />
        </div>
      }
    </mat-expansion-panel>

    <mat-expansion-panel (opened)="panelFinancial = true">
      <mat-expansion-panel-header>
        <mat-panel-title> <h4>Financeiro</h4> </mat-panel-title>
      </mat-expansion-panel-header>
      @if (panelFinancial) {
        <div>
          <div [formGroup]="formFinancial">
            <div class="flex justify-between gap-4 items-center">
              <mat-slide-toggle
                class="input-tg w-2/12 p-bottom-toggle px-2"
                formControlName="tgmob"
                (change)="onChangeSelect($event)"
                >{{
                  formFinancial.get('tgmob')?.value ? 'tg.mob' : 'Cliente'
                }}</mat-slide-toggle
              >
              <mat-form-field class="input-tg w-2/12" appearance="outline">
                <mat-label>Comissão</mat-label>
                @if (formFinancial.get('commission')!.value != '') {
                  <span matTextSuffix>%&nbsp;</span>
                }
                <input matInput formControlName="commission" decimalInput />
              </mat-form-field>
              <mat-form-field class="input-tg w-2/12" appearance="outline">
                <mat-label>Divisor</mat-label>
                <input matInput formControlName="divider" decimalInput />
              </mat-form-field>
              <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
                <mat-label>Taxa</mat-label>
                @if (formFinancial.get('tax')!.value != '') {
                  <span matTextSuffix>%&nbsp;</span>
                }
                <input matInput formControlName="tax" currencyInput />
              </mat-form-field>
              <div class="w-8/12"></div>
            </div>
          </div>
          <mat-divider></mat-divider>
          <h4 class="font-normal">Tipo documento Fiscal</h4>
          <tax-document-client-create
            (response)="getList($event, 'taxDocument')"
          />
          <mat-divider></mat-divider>
          <h4 class="font-normal">Forma Pagamento</h4>
          <payment-methods-client-create
            (response)="getList($event, 'paymentMethod')"
          />
        </div>
      }
    </mat-expansion-panel>

    <mat-expansion-panel (opened)="panelBankDetails = true">
      <mat-expansion-panel-header>
        <mat-panel-title> <h4>Dados bancários</h4> </mat-panel-title>
      </mat-expansion-panel-header>
      @if (panelBankDetails) {
        <div>
          <bank-details-client-create
            (response)="getList($event, 'bankDetails')"
          />
        </div>
      }
    </mat-expansion-panel>

    <mat-expansion-panel (opened)="panelConsultant = true">
      <mat-expansion-panel-header>
        <mat-panel-title> <h4>Consultores</h4> </mat-panel-title>
      </mat-expansion-panel-header>
      @if (panelConsultant) {
        <div>
          <consultant-client-create
            (response)="getList($event, 'consultant')"
          />
        </div>
      }
    </mat-expansion-panel>

    <mat-expansion-panel (opened)="panelConsultantOp = true">
      <mat-expansion-panel-header>
        <mat-panel-title> <h4>Consultores Operacional</h4> </mat-panel-title>
      </mat-expansion-panel-header>
      @if (panelConsultantOp) {
        <div>
          <associate-consultant-operate-create
            (response)="getList($event, 'associateConsultantOp')"
          />
        </div>
      }
    </mat-expansion-panel>

    <mat-expansion-panel (opened)="panelTariff = true">
      <mat-expansion-panel-header>
        <mat-panel-title> <h4>Tarifário</h4> </mat-panel-title>
      </mat-expansion-panel-header>
      @if (panelTariff) {
        <div>
          <tariff-client-create (response)="getList($event, 'tariff')" />
        </div>
      }
    </mat-expansion-panel>
  </mat-accordion>
</mat-card>
